import { render, staticRenderFns } from "./Trends.vue?vue&type=template&id=7f8fd323&"
import script from "./Trends.vue?vue&type=script&lang=js&"
export * from "./Trends.vue?vue&type=script&lang=js&"
import style0 from "./Trends.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports